import React, { useEffect } from "react";
import { Title } from "../contents/dynamic.components";
import {
  componentAnimationReadyToPlay,
  componentAnimationReadyToStop,
} from "src/utils/helper";
import { playCustomAnimation } from "src/services/animations";
import { useStore } from "src/store";

export const SidebarWrapper = ({ children }: { children: JSX.Element }) => {
  const {
    activeSubLink,
    setAnimationStopped,
    sidebarStatus,
    animationStopped,
  } = useStore();

  useEffect(() => {
    if (componentAnimationReadyToPlay(activeSubLink.id)) {
      playCustomAnimation();
    }
    if (componentAnimationReadyToStop(activeSubLink.id)) {
      setAnimationStopped(true);
    }
  }, [sidebarStatus, animationStopped]);

  return (
    <>
      <Title title={activeSubLink.title} />
      {children}
    </>
  );
};
